import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../icon/icon';
import FormValidationMessage from '../formValidationMessage/formValidationMessage';
import './form-field.scss';

const FormField = ({ icon, children, errors }) => {
    function getClassNames() {
        if(children && children.props.name === 'termsAndConditions') {
            return 'input-wrapper without-border'
        }

        if (errors && errors.length !== 0) {
            return 'input-wrapper has-errors'
        }

        return 'input-wrapper'
    };
    
    return (
        <>
            <div className={ getClassNames() }>
                { icon && <Icon type={ icon } /> }
                { children }
            </div>
            
            <div className='error-wrapper'>
                { errors && errors.map(error => {
                    return (
                        <FormValidationMessage
                            key={ error }
                            errorMessage={ error }
                        />
                    );
                })}
            </div>
        </>
    );
};

FormField.propTypes = {
    icon: PropTypes.string,
    errors: PropTypes.array,
    children: PropTypes.node,
};
export default FormField;
